































import { Component, Vue, Mixins, Watch } from "vue-property-decorator";

import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
import loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
import debounce from "@/utils/debounce";
import inputPrice from "@/utils/inputPrice";

@Component({
  components: {
    Header,
    Table,
  },
})
export default class Order extends Vue {
  fromDate: string | null = "";
  toDate: string | null = "";
  productName: string = "";
  shopName: string = "";
  phone: string = "";
  memberName: string = "";
  expressNo: string = "";
  orderStatus: string = "";

  // 退款笔数
  total: number = 0;

  /**
   * 监听
   */
  @Watch("productName")
  @Watch("shopName")
  @Watch("phone")
  @Watch("memberName")
  @Watch("expressNo")
  @Watch("orderStatus")
  searchValue() {
    debounce(() => this.handleSearch());
  }

  /**
   * methods
   */

  // 输入
  inputValue(val: string, type: string) {
    let self: any = this;
    if (type == "expressNo") {
      self[type] = inputPrice(val, "number");
      return;
    }
    self[type] = val;
  }
  // 搜索
  handleSearch() {
    let table: any = this.$refs.table;
    table.getData();
  }
  // 获取退款笔数
  getTotal(val: number) {
    this.total = val;
  }
}
